import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../variables';
import GlobalStyles from '../global-styles';
import Head from './head';
import SecondaryNav from '../components/secondary-nav/secondary-nav';
import SignUpFooterLink from '../components/sign-up-footer-link/sign-up-footer-link';
import FooterBlock from '../blocks/footer-block/footer-block';
import { Navbar } from '../blocks/navbar-block/navbar-block';
import { StyledNav } from '../blocks/navbar-block/navbar-block.styles';

const Layout = ({
  secondaryNavData,
  footerData,
  translate = true,
  children,
  className,
  metaData = {},
  gtmDataLayerVars = {},
  hreflangUrls,
  hasTopPadding = false,
  navbarInitialNoBackground = false,
  navbarInitialLightText = false,
  globals = [],
  pageUrl = null,
  navbarLocaleLinks,
}) => {
  return (
    <div className={className}>
      <GlobalStyles />
      <Head
        metaData={metaData}
        gtmVars={gtmDataLayerVars}
        hreflangUrls={hreflangUrls}
        pageUrl={pageUrl}
      />
      <Navbar
        locale={metaData.localeCode || 'en-GB'}
        initialNoBackground={navbarInitialNoBackground}
        initialLightText={navbarInitialLightText}
        navbarLocaleLinks={navbarLocaleLinks}
      />
      <PageWrapper
        hasTopPadding={hasTopPadding}
        withSecondaryNav={!!secondaryNavData}
      >
        {secondaryNavData && (
          <SecondaryNav
            title={secondaryNavData.title}
            tabs={secondaryNavData.tabs}
            colour={secondaryNavData.colour}
            role="navigation"
            aria-label="Secondary navigation"
          />
        )}

        {children}
      </PageWrapper>
      <SignUpFooterLink
        backgroundImageSrc={
          globals?.signUpBackgroundImage?.file?.url
            ? `${globals?.signUpBackgroundImage?.file?.url}?fm=webp`
            : null
        }
        ctaUrl="/newsletter-sign-up"
      />
      <FooterBlock footerData={{ ...footerData, translate: translate }} />
    </div>
  );
};

const PageWrapper = styled.div`
  padding-top: ${({ hasTopPadding }) => {
    if (hasTopPadding) return '0';
    return vars.primaryNavHeight;
  }};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding-top: ${({ withSecondaryNav }) => {
      return withSecondaryNav ? `calc(${vars.spacingXxl} * 2.2)` : '0';
    }};
  }
`;

const StyledLayout = styled(Layout)`
  ${FooterBlock} {
    display: none;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    ${FooterBlock} {
      display: block;
    }
  }

  @media print {
    ${StyledNav},
    ${SecondaryNav},    
    ${FooterBlock}, 
    
    .main-container .main-content-container {
      padding: 0;
    }
  }
`;

export default StyledLayout;
